import { useEffect } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ExitIntentModal } from './components/ExitIntentModal';
import { MetaPixel } from './components/MetaPixel';
// Helper: ensure a <meta> tag with given attributes exists in <head>
const ensureMeta = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = Object.entries(attrs).filter(([k]) => k !== 'content').map(([k, v]) => `[${k}="${v}"]`).join('');
  let meta = document.head.querySelector<HTMLMetaElement>(`meta${selector}`);
  if (!meta) {
    meta = document.createElement('meta');
    document.head.appendChild(meta);
  }
  Object.entries(attrs).forEach(([k, v]) => meta!.setAttribute(k, v));
};
// Helper: ensure a <link> tag exists in <head>
const ensureLink = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = `link[rel="${attrs.rel}"][href="${attrs.href}"]`;
  if (document.head.querySelector(selector)) return;
  const link = document.createElement('link');
  Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
  document.head.appendChild(link);
};
export function App() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // Language + translation blocking (Spanish - Latin America)
    document.documentElement.lang = 'es-419';
    document.documentElement.setAttribute('translate', 'no');
    document.title = 'Biblioteca Maestra del Código de los Chakras — Todo tu sistema, organizado';
    ensureMeta({
      'http-equiv': 'content-language',
      content: 'es-419'
    });
    ensureMeta({
      name: 'google',
      content: 'notranslate'
    });
    ensureMeta({
      name: 'language',
      content: 'Spanish'
    });
    ensureMeta({
      name: 'description',
      content: 'Biblioteca Maestra del Código de los Chakras: 6 Módulos, 475 páginas, 5 bonos exclusivos. Todo tu sistema de terapia energética organizado desde hoy por 15 USD. Pagas en tu moneda local.'
    });
    ensureMeta({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover'
    });
    // Performance: preconnect to Google Fonts (faster font load)
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    // Performance: preconnect to the CDN serving the hero mockup
    ensureLink({
      rel: 'preconnect',
      href: 'https://cdn.magicpatterns.com'
    });
    ensureLink({
      rel: 'preload',
      as: 'image',
      href: 'https://cdn.magicpatterns.com/uploads/aiAoxphTtZMJYC7JTizVDH/Mockup_stiker.png',
      // @ts-ignore
      fetchpriority: 'high'
    });
    // Performance: warm up the checkout connection so CTA clicks navigate
    // instantly. TCP + TLS happens in the background while the user reads.
    ensureLink({
      rel: 'dns-prefetch',
      href: 'https://biblioteca-de-los-chakras.impultienda.ar'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://biblioteca-de-los-chakras.impultienda.ar',
      crossorigin: ''
    });
    // Performance: resolve the pixel host early without blocking the paint
    ensureLink({
      rel: 'dns-prefetch',
      href: 'https://connect.facebook.net'
    });
  }, []);
  return <div lang="es-419" translate="no" className="min-h-screen bg-bg-base font-sans text-txt-body selection:bg-brandViolet selection:text-white notranslate" data-id="element-0" data-mp="1m4ej9rf2rbbh">
      <MetaPixel data-id="element-1" data-mp="apr8j7ukp4tz" />
      <SocialProofPopup data-id="element-2" data-mp="aq9aml3x2d9t" />
      <ExitIntentModal data-id="element-3" data-mp="arkfypd0ft31" />
      <Hero data-id="element-4" data-mp="anwn7sfe3apd" />
      <SocialProof data-id="element-5" data-mp="qx5f5v2uoi8w" />
      <Testimonials1 data-id="element-6" data-mp="qxnmpnuyqiw4" />
      <Problem data-id="element-7" data-mp="qy714ulemp5e" />
      <ProductTomos data-id="element-8" data-mp="qyqa3lt2u37a" />
      <Bonuses data-id="element-9" data-mp="qyyoxj8rfil4" />
      <UrgencyCounter data-id="element-10" data-mp="m6f8meiou9cm" />
      <Pricing data-id="element-11" data-mp="m65j0s1k247g" />
      <Testimonials2 data-id="element-12" data-mp="m5nel84qojog" />
      <Guarantee data-id="element-13" data-mp="m549is06tpru" />
      <FAQ data-id="element-14" data-mp="m4m16x093l3k" />
      <CostOfNotHaving data-id="element-15" data-mp="h7c7v69qqpag" />
      <FinalCTA data-id="element-16" data-mp="h6kmspdrs9yf" />
      <Footer data-id="element-17" data-mp="h843gh3c8n0q" />
    </div>;
}